export default "__VITE_ASSET__6HFk_UPS__"